'use strict';

var $u = require('../utilities');
var $d = require('../dependency');
var _ = $d._;
var moment = $d.moment;

exports.afterApiBucketFields = afterApiBucketFields;

function afterApiBucketFields(context, config, next) {
  var apiParsedResponseList = context.apiParsedResponseList,
    apiMergedResponse = {},
    bucketList,
    groupNameValuesMap,
    groupNameCountMap,
    bucketReturnValue,
    maxBucketVal,
    createLastBucket,
    returnEmptyBuckets,
    lastBucketPrefix;
  apiParsedResponseList = apiParsedResponseList[0];
  /**
   apiParsedResponseList = [{
                    customer:['a','a','a','a','a'],
                    ssidCount:[5,5,5,5,5],
                    ssidCountBuckets:[undefined,undefined,undefined,undefined,undefined]
                }];

   apiParsedResponseList = [{
                    customer:[],
                    ssidCount:[],
                    ssidCountBuckets:[]
                }];

   */

  bucketList = _.clone(config.buckets);
  createLastBucket = config.createLastBucket;
  returnEmptyBuckets = config.returnEmptyBuckets;
  lastBucketPrefix = config.lastBucketPrefix;
  _.forEach(config.seriesToBucket, function (field) {
    groupNameValuesMap = {};
    groupNameCountMap = {};

    groupNameValuesMap = _.groupBy(apiParsedResponseList[field], function (val) {
      _.forEach(bucketList, function (bucketValue) {
        if (val === bucketValue) {
          bucketReturnValue = bucketValue.toString();
        }
      });

      if (createLastBucket) {
        maxBucketVal = _.max(bucketList);
        if (val > maxBucketVal) {
          bucketReturnValue = lastBucketPrefix + maxBucketVal;
        }
      }

      return bucketReturnValue;
    });

    //This is to ensure that this bucket is counted for filling if it is empty in the returnEmptyBuckets code below.
    if (createLastBucket) {
      bucketList.push(lastBucketPrefix + _.max(bucketList));
    }

    if (returnEmptyBuckets) {
      _.forEach(bucketList, function (bucketValue) {
        if (_.findIndex(
            _.keys(groupNameValuesMap),
            function (key) {
              if (key === bucketValue.toString()) {
                return true;
              }
            }) === -1) {
          groupNameValuesMap[bucketValue.toString()] = [];
        }
      });
    }


    _.forEach(groupNameValuesMap, function (value, key) {
      groupNameCountMap[key] = value.length;
    });

    apiMergedResponse[field] = groupNameCountMap;
  });

  context.apiMergedResponse = apiMergedResponse;
  next();
}